
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.747 7.466L5.144 20.577A.521.521 0 005 20.94v1.72c0 .286.225.513.493.513h1.64a.495.495 0 00.357-.15L20.1 9.914a.528.528 0 000-.727l-1.654-1.72a.48.48 0 00-.699 0zm4.449-1.233l-.899-.934-.012-.013A1.08 1.08 0 0020.567 5c-.274 0-.53.11-.723.292l-.705.74a.27.27 0 000 .363l.648.675 1.354 1.409c.1.104.256.104.356 0l.705-.734c.175-.2.275-.46.275-.752a1.201 1.201 0 00-.281-.76z","fill-rule":"nonzero"}})])
          )
        }
      }
    